/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
import {PopulateAreaSpecificData} from '../areaContracts'

export const populateSyncProfileData: PopulateAreaSpecificData = async ({}) => {}
